export const ASSETS_EDIT_SECTIONS = {
  FORM: 'form',
  DEPRECIATION: 'depreciation',
  NOTES: 'notes',
  FILES: 'files',
  HISTORICS: 'historics',
  BILL: 'bill',
  CUSTOMSDOCUMENTS: "customsDocuments"
};



// WEBPACK FOOTER //
// src/components/assets/constants.js